export class TriggerTime {
    public Time: string;
}
